var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ListService } from './list.service';
var ListGroupComponent = /** @class */ (function (_super) {
    __extends(ListGroupComponent, _super);
    function ListGroupComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    ListGroupComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ListGroupComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ListGroupComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ListGroupComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'listgroup',
                    template: "<div class=\"row\">\n  <div class=\"col-sm-6\">\n    <listcount [componentName]=\"componentName + '#listcount'\" [component]=\"{name: componentName}\"></listcount>\n  </div>\n  <div class=\"col-sm-6 -txtalnright\">\n    <rows [componentName]=\"componentName + '#rows'\" [component]=\"{name: componentName, params: component.params}\"></rows>\n  </div>\n</div>\n<div class=\"row -my-1\">\n  <div class=\"col-sm-12\">\n    <list [parentComponentName]=\"componentName\" [componentName]=\"componentName + '#list'\" [component]=\"{name: componentName, model: component.model, params: component.params}\"></list>\n  </div>\n</div>\n<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <pager [componentName]=\"componentName + '#pager'\" [component]=\"{name: componentName, params: component.params}\"></pager>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    ListGroupComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService }
    ]; };
    return ListGroupComponent;
}(ContentBaseComponent));
export { ListGroupComponent };
//# sourceMappingURL=listgroup.component.js.map